import iconActive from 'assets/seller/play-status.svg';
import iconPaused from 'assets/seller/pause-status.svg';
import iconWarning from 'assets/seller/warning.svg';
import {getConnectionChannelIdByName} from 'utils/seller/sellerConnectionData';

const errorOzonHintText = {
  textBefore: 'Проверьте статус кампании на маркетплейсе и',
  textAfter: '',
  link: '/seller/shop',
  linkText: 'доступ к магазину'
};

export const getListSellerFactStatus = (channelId) => [
  {
    id: 'RUNNING',
    name: 'Активна',
    icon: {
      link: iconActive,
      width: '8px',
      height: '10px'
    },
    bgColor: 'rgba(201, 238, 227, 1)',
    contentColor: 'rgba(63, 145, 128, 1)',
    secondAction: {
      icon: {
        link: iconPaused,
        width: '7px',
        height: '10px'
      },
      bgColor: 'rgba(206, 227, 248, 1)',
      contentColor: 'rgba(85, 133, 193, 1)',
      disabledBgColor: 'rgba(245, 245, 245, 1)',
      disabledContentColor: 'rgba(196, 196, 196, 1)',
      hintText: 'Остановить',
      actionType: 'pause-campaign'
    }
  },
  {
    id: 'PAUSED',
    name: 'Остановлена',
    icon: {
      link: iconPaused,
      width: '7px',
      height: '10px'
    },
    hintText: channelId === getConnectionChannelIdByName('wildberries')
      ? 'Кампания остановлена на&nbsp;маркетплейсе — вручную или&nbsp;из-за нехватки бюджета'
      : null,
    bgColor: 'rgba(206, 227, 248, 1)',
    contentColor: 'rgba(85, 133, 193, 1)',
    secondAction: {
      icon: {
        link: iconActive,
        width: '8px',
        height: '10px'
      },
      bgColor: 'rgba(201, 238, 227, 1)',
      contentColor: 'rgba(63, 145, 128, 1)',
      disabledBgColor: 'rgba(245, 245, 245, 1)',
      disabledContentColor: 'rgba(196, 196, 196, 1)',
      hintText: 'Запустить',
      actionType: 'start-campaign'
    }
  },
  {
    id: 'PAUSED_BY_SCHEDULE',
    name: 'Остановлена по расписанию',
    icon: {
      link: iconPaused,
      width: '7px',
      height: '10px'
    },
    hintText: 'Кампания возобновит работу по&nbsp;заданному вами расписанию',
    bgColor: 'rgba(206, 227, 248, 1)',
    contentColor: 'rgba(85, 133, 193, 1)'
  },
  {
    id: 'PAUSED_BY_BID_MANAGER',
    name: 'Остановлена стратегией',
    icon: {
      link: iconPaused,
      width: '7px',
      height: '10px'
    },
    hintText: 'Стратегия возобновит работу кампании автоматически',
    bgColor: 'rgba(206, 227, 248, 1)',
    contentColor: 'rgba(85, 133, 193, 1)'
  },
  {
    id: 'BUDGET_IS_EXHAUSTED',
    name: 'Бюджет исчерпан',
    hintText: 'Пополните бюджет на&nbsp;маркетплейсе или дождитесь начала новой недели',
    icon: {
      link: iconWarning,
      width: '13px',
      height: '12px'
    },
    bgColor: 'rgba(251, 239, 210, 1)',
    contentColor: 'rgba(138, 105, 1, 1)'
  },
  {
    id: 'START_DATE_IN_FUTURE',
    name: 'Ожидает дату старта',
    icon: null,
    bgColor: 'transparent',
    contentColor: 'rgba(168, 168, 168, 1)'
  },
  {
    id: 'UNDER_MODERATION',
    name: 'На модерации',
    icon: null,
    bgColor: 'transparent',
    contentColor: 'rgba(168, 168, 168, 1)'
  },
  {
    id: 'END_DATE_IN_PAST',
    name: 'Завершена',
    icon: null,
    bgColor: 'transparent',
    contentColor: 'rgba(168, 168, 168, 1)'
  },
  {
    id: 'ARCHIVED',
    name: 'Архивирована',
    icon: null,
    bgColor: 'transparent',
    contentColor: 'rgba(168, 168, 168, 1)'
  },
  {
    id: 'SUBSCRIPTION_CANCELED',
    name: 'Больше не обновляется',
    hintText: 'Продлите подписку, чтобы&nbsp;сервис продолжил управлять ставками и&nbsp;обновлял статусы кампаний',
    icon: null,
    bgColor: 'transparent',
    contentColor: 'rgba(168, 168, 168, 1)'
  },
  {
    id: 'ERROR',
    name: 'Ошибка',
    icon: {
      link: iconWarning,
      width: '13px',
      height: '12px'
    },
    hintText: errorOzonHintText,
    bgColor: 'rgba(252, 215, 212, 1)',
    contentColor: 'rgba(216, 77, 77, 1)'
  }
];

export const getSellerDetailFactStatusById = (factStatusId, channelId) => {
  const listSellerFactStatus = getListSellerFactStatus(channelId);
  return listSellerFactStatus.find(status => status.id === factStatusId);
};

export const getSellerFactStatusTypesListForSort = () => {
  const listSellerFactStatus = getListSellerFactStatus();
  return listSellerFactStatus.filter(status => status.id !== 'ERROR' && status.id !== 'SUBSCRIPTION_CANCELED');
};
